import './App.css';
import { lazy, Suspense, useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';

// Lazy load below-the-fold components for faster initial render
const About = lazy(() => import('./components/About'));
const Clients = lazy(() => import('./components/Clients'));
const Services = lazy(() => import('./components/Services'));
const Portfolio = lazy(() => import('./components/Portfolio'));
const Counts = lazy(() => import('./components/Counts'));
const Team = lazy(() => import('./components/Team'));
const Contact = lazy(() => import('./components/Contact'));
const BackToTop = lazy(() => import('./components/BackToTop'));

function App() {
  useEffect(() => {
    // Hide preloader immediately
    const hidePreloader = () => {
      const preloader = document.getElementById('preloader');
      if (preloader) {
        preloader.style.display = 'none';
        preloader.style.visibility = 'hidden';
        preloader.style.opacity = '0';
      }
    };

    hidePreloader();
  }, []);

  return (
    <div className="app-container">
      <Header />
      <Hero />
      <main id="main">
        <Suspense fallback={null}>
          <About />
          <Clients />
          <Services />
          <Portfolio />
          <Counts />
          <Team />
          <Contact />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <BackToTop />
      </Suspense>
    </div>
  );
}

export default App;
